import * as type from './types';
import { createReducer } from "../../util/index";

//Set the initial state for the current page , current limit and current search values
const initialState = {
    data: []
};

const promoteLinkReducer = createReducer(initialState) ({
    [type.GET_LINK]: (state, action) => ({
        ...state,
        get_link: action.payload,
    }),
});

export default promoteLinkReducer;